import { render, staticRenderFns } from "./viewOverridesV2.vue?vue&type=template&id=7bd0e038&"
import script from "./viewOverridesV2.vue?vue&type=script&lang=js&"
export * from "./viewOverridesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd0e038')) {
      api.createRecord('7bd0e038', component.options)
    } else {
      api.reload('7bd0e038', component.options)
    }
    module.hot.accept("./viewOverridesV2.vue?vue&type=template&id=7bd0e038&", function () {
      api.rerender('7bd0e038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Overrides/viewOverridesV2.vue"
export default component.exports